import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["backdrop"];

  open(event) {
    event?.preventDefault();
    if (!this.hasBackdropTarget) return;
    this.backdropTarget.classList.remove("hidden");
    this.backdropTarget.classList.add("flex");
    document.body.style.overflow = "hidden";
  }

  close() {
    if (!this.hasBackdropTarget) return;
    this.backdropTarget.classList.add("hidden");
    this.backdropTarget.classList.remove("flex");
    document.body.style.overflow = "";
  }

  backdropClose(event) {
    if (event.target === this.backdropTarget) {
      this.close();
    }
  }

  disconnect() {
    document.body.style.overflow = "";
  }
}
